import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { FenceType } from '@casops/store/apis/geofencesApi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useLegacyFenceTypesOptions = (): DropdownItemProps<FenceType>[] => {
  const { t } = useTranslation();

  const items = useMemo(() => {
    return Object.values(FenceType)
      .map((value: FenceType) => {
        return {
          key: value,
          value,
          stringValue: value,
          label: t(`FenceType.${value}`),
        };
      })
      .sort((a, b) => a.stringValue.localeCompare(b.stringValue));
  }, [t]);

  return items;
};
